var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "700px",
            wrapperClosable: _vm.type == "check" ? true : false,
            "before-close": _vm.handleCloseFn,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { ref: "scrollRef", staticClass: "box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: "班次名称：", prop: "name" },
                    },
                    [
                      _vm.type !== "check"
                        ? _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("el-input", {
                                staticStyle: { width: "90%" },
                                attrs: {
                                  size: "small",
                                  placeholder: "请输入班次名称",
                                },
                                model: {
                                  value: _vm.formData.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "name", $$v)
                                  },
                                  expression: "formData.name",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-color-picker", {
                                staticClass: "ml14",
                                model: {
                                  value: _vm.formData.color,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "color", $$v)
                                  },
                                  expression: "formData.color",
                                },
                              }),
                            ],
                            1
                          )
                        : _c("span", [_vm._v(_vm._s(_vm.formData.name))]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: "上下班次数：", prop: "number" },
                    },
                    [
                      _vm.type !== "check"
                        ? _c(
                            "el-radio-group",
                            {
                              on: { input: _vm.radioFn },
                              model: {
                                value: _vm.formData.number,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "number", $$v)
                                },
                                expression: "formData.number",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("一次上下班"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("两次上下班"),
                              ]),
                            ],
                            1
                          )
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formData.number == 1
                                  ? "一次上下班"
                                  : "两次上下班"
                              )
                            ),
                          ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: "工作时长：", prop: "title" },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.formData.work_time))])]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "mb20",
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.tableData },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "班次", width: "140" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "rule", label: "规则" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.rule == 1
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item" },
                                          [
                                            _vm._v(
                                              "\n                  上班时间  \n                  "
                                            ),
                                            _vm.type !== "check"
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "150px",
                                                    },
                                                    attrs: {
                                                      disabled: "",
                                                      size: "small",
                                                      placeholder: "请选择",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formData.number1
                                                          .first_day_after,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formData.number1,
                                                          "first_day_after",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formData.number1.first_day_after",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.options,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.value,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.type !== "check"
                                              ? _c("el-time-picker", {
                                                  staticClass: "ml10",
                                                  staticStyle: {
                                                    width: "150px",
                                                  },
                                                  attrs: {
                                                    clearable: false,
                                                    size: "small",
                                                    format: "H:mm",
                                                    placeholder: "选择时间",
                                                  },
                                                  on: {
                                                    change: _vm.changeTime,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.number1
                                                        .work_hours,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.number1,
                                                        "work_hours",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.number1.work_hours",
                                                  },
                                                })
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formData.number1
                                                        .first_day_after == 0
                                                        ? "当日"
                                                        : "次日"
                                                    ) +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            _vm.formData.number1
                                                              .work_hours
                                                          )
                                                          .format("H:mm")
                                                      )
                                                  ),
                                                ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.goToWork1,
                                          function (item, index) {
                                            return _vm.type !== "check"
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.premise) +
                                                        "\n\n                  "
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mo-input--number",
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            "controls-position":
                                                              "right",
                                                            size: "small",
                                                            min: 0,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form[
                                                                item.hour
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                item.hour,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form[item.hour]",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "define-append",
                                                          },
                                                          [_vm._v("小时")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mo-input--number",
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            "controls-position":
                                                              "right",
                                                            size: "small",
                                                            min: 0,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form[
                                                                item.minute
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                item.minute,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form[item.minute]",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "define-append",
                                                          },
                                                          [_vm._v("分钟")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(
                                                      "\n                   \n                  " +
                                                        _vm._s(item.suffix) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.goToWork1,
                                          function (item, index) {
                                            return _vm.type == "check"
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.premise) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.form[item.hour]
                                                        ) +
                                                        " 小时" +
                                                        _vm._s(
                                                          _vm.form[item.minute]
                                                        ) +
                                                        " 分钟" +
                                                        _vm._s(item.suffix) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.rule == 2
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item" },
                                          [
                                            _vm._v(
                                              "\n                  下班时间 \n                  "
                                            ),
                                            _vm.type !== "check"
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "150px",
                                                    },
                                                    attrs: {
                                                      size: "small",
                                                      placeholder: "请选择",
                                                    },
                                                    on: {
                                                      change: _vm.changeTime,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formData.number1
                                                          .second_day_after,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formData.number1,
                                                          "second_day_after",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formData.number1.second_day_after",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.options,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.value,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.type !== "check"
                                              ? _c("el-time-picker", {
                                                  staticClass: "ml10",
                                                  staticStyle: {
                                                    width: "150px",
                                                  },
                                                  attrs: {
                                                    clearable: false,
                                                    size: "small",
                                                    format: "H:mm",
                                                    placeholder: "选择时间",
                                                  },
                                                  on: {
                                                    change: _vm.changeTime,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.number1
                                                        .off_hours,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.number1,
                                                        "off_hours",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.number1.off_hours",
                                                  },
                                                })
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formData.number1
                                                        .second_day_after == 0
                                                        ? "当日"
                                                        : "次日"
                                                    ) +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            _vm.formData.number1
                                                              .off_hours
                                                          )
                                                          .format("H:mm")
                                                      )
                                                  ),
                                                ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.goToWork2,
                                          function (item, index) {
                                            return _vm.type !== "check"
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.premise) +
                                                        "\n                  "
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mo-input--number",
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            "controls-position":
                                                              "right",
                                                            size: "small",
                                                            min: 0,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form[
                                                                item.hour
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                item.hour,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form[item.hour]",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "define-append",
                                                          },
                                                          [_vm._v("小时")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mo-input--number",
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            "controls-position":
                                                              "right",
                                                            size: "small",
                                                            min: 0,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form[
                                                                item.minute
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                item.minute,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form[item.minute]",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "define-append",
                                                          },
                                                          [_vm._v("分钟")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(item.suffix) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm.type !== "check"
                                          ? _c(
                                              "el-checkbox",
                                              {
                                                model: {
                                                  value: _vm.form.free_clock,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "free_clock",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.free_clock",
                                                },
                                              },
                                              [_vm._v("下班可免打卡")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.goToWork2,
                                          function (item, index) {
                                            return _vm.type == "check"
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.premise) +
                                                        " "
                                                    ),
                                                    _vm.form[item.hour] !== 0
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.form[
                                                                item.hour
                                                              ]
                                                            ) + " 小时"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.form[item.minute] !== 0
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.form[
                                                                item.minute
                                                              ]
                                                            ) + " 分钟"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(
                                                      _vm._s(item.suffix) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm.type == "check"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.form.free_clock
                                                    ? "下班可免打卡"
                                                    : "下班不可免打卡"
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.rule == 3
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item" },
                                          [
                                            _vm._v(
                                              "\n                  上班时间 \n                  "
                                            ),
                                            _vm.type !== "check"
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "150px",
                                                    },
                                                    attrs: {
                                                      placeholder: "请选择",
                                                      size: "small",
                                                      disabled:
                                                        _vm.formData.number1
                                                          .second_day_after ==
                                                        1,
                                                    },
                                                    on: {
                                                      change: _vm.changeTime,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formData.number2
                                                          .first_day_after,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formData.number2,
                                                          "first_day_after",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formData.number2.first_day_after",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.options,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.value,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.type !== "check"
                                              ? _c("el-time-picker", {
                                                  staticClass: "ml10",
                                                  staticStyle: {
                                                    width: "150px",
                                                  },
                                                  attrs: {
                                                    size: "small",
                                                    clearable: false,
                                                    format: "H:mm",
                                                    placeholder: "选择时间",
                                                  },
                                                  on: {
                                                    change: _vm.changeTime,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.number2
                                                        .work_hours,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.number2,
                                                        "work_hours",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.number2.work_hours",
                                                  },
                                                })
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formData.number2
                                                        .first_day_after == 0
                                                        ? "当日"
                                                        : "次日"
                                                    ) +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            _vm.formData.number2
                                                              .work_hours
                                                          )
                                                          .format("H:mm")
                                                      )
                                                  ),
                                                ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.goToWork1,
                                          function (item, index) {
                                            return _vm.type !== "check"
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.premise) +
                                                        "\n                  "
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mo-input--number",
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            "controls-position":
                                                              "right",
                                                            size: "small",
                                                            min: 0,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form1[
                                                                item.hour
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form1,
                                                                item.hour,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form1[item.hour]",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "define-append",
                                                          },
                                                          [_vm._v("小时")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mo-input--number",
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            "controls-position":
                                                              "right",
                                                            size: "small",
                                                            min: 0,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form1[
                                                                item.minute
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form1,
                                                                item.minute,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form1[item.minute]",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "define-append",
                                                          },
                                                          [_vm._v("分钟")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(
                                                      "\n                   " +
                                                        _vm._s(item.suffix) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.goToWork1,
                                          function (item, index) {
                                            return _vm.type == "check"
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.premise) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.form1[item.hour]
                                                        ) +
                                                        " 小时" +
                                                        _vm._s(
                                                          _vm.form1[item.minute]
                                                        ) +
                                                        " 分钟" +
                                                        _vm._s(item.suffix) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.rule == 4
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item" },
                                          [
                                            _vm._v(
                                              "\n                  下班时间  \n                  "
                                            ),
                                            _vm.type !== "check"
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "150px",
                                                    },
                                                    attrs: {
                                                      placeholder: "请选择",
                                                      size: "small",
                                                      disabled:
                                                        _vm.formData.number2
                                                          .first_day_after == 1,
                                                    },
                                                    on: {
                                                      change: _vm.changeTime,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formData.number2
                                                          .second_day_after,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formData.number2,
                                                          "second_day_after",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formData.number2.second_day_after",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.options,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.value,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.type !== "check"
                                              ? _c("el-time-picker", {
                                                  staticClass: "ml10",
                                                  staticStyle: {
                                                    width: "150px",
                                                  },
                                                  attrs: {
                                                    size: "small",
                                                    clearable: false,
                                                    format: "H:mm",
                                                    placeholder: "选择时间",
                                                  },
                                                  on: {
                                                    change: _vm.changeTime,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.number2
                                                        .off_hours,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.number2,
                                                        "off_hours",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.number2.off_hours",
                                                  },
                                                })
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formData.number2
                                                        .second_day_after == 0
                                                        ? "当日"
                                                        : "次日"
                                                    ) +
                                                      _vm._s(
                                                        _vm
                                                          .$moment(
                                                            _vm.formData.number2
                                                              .off_hours
                                                          )
                                                          .format("H:mm")
                                                      )
                                                  ),
                                                ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.goToWork2,
                                          function (item, index) {
                                            return _vm.type !== "check"
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.premise) +
                                                        "\n                  "
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mo-input--number",
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            "controls-position":
                                                              "right",
                                                            size: "small",
                                                            min: 0,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form1[
                                                                item.hour
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form1,
                                                                item.hour,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form1[item.hour]",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "define-append",
                                                          },
                                                          [_vm._v("小时")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mo-input--number",
                                                      },
                                                      [
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            "controls-position":
                                                              "right",
                                                            size: "small",
                                                            min: 0,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form1[
                                                                item.minute
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form1,
                                                                item.minute,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form1[item.minute]",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "define-append",
                                                          },
                                                          [_vm._v("分钟")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(
                                                      "\n                   " +
                                                        _vm._s(item.suffix) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm.type !== "check"
                                          ? _c(
                                              "el-checkbox",
                                              {
                                                model: {
                                                  value: _vm.form1.free_clock,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form1,
                                                      "free_clock",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form1.free_clock",
                                                },
                                              },
                                              [_vm._v("下班可免打卡")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.goToWork2,
                                          function (item, index) {
                                            return _vm.type == "check"
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(item.premise) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.form[item.hour]
                                                        ) +
                                                        " 小时" +
                                                        _vm._s(
                                                          _vm.form[item.minute]
                                                        ) +
                                                        " 分钟" +
                                                        _vm._s(item.suffix) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm.type == "check"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.form1.free_clock
                                                    ? "下班可免打卡"
                                                    : "下班不可免打卡"
                                                )
                                              ),
                                            ])
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formData.number == 1 && _vm.type !== "check"
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { slot: "label" },
                              on: { change: _vm.changeTime },
                              slot: "label",
                              model: {
                                value: _vm.formData.rest_time,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "rest_time", $$v)
                                },
                                expression: "formData.rest_time",
                              },
                            },
                            [_vm._v("中途休息时间：")]
                          ),
                          _vm._v(" "),
                          _vm.type !== "check"
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "ml20",
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    placeholder: "请选择",
                                    size: "small",
                                    disabled:
                                      _vm.formData.number1.second_day_after ==
                                      0,
                                  },
                                  on: { change: _vm.changeTime },
                                  model: {
                                    value: _vm.formData.rest_start_after,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "rest_start_after",
                                        $$v
                                      )
                                    },
                                    expression: "formData.rest_start_after",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-time-picker", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              clearable: false,
                              format: "H:mm",
                              size: "small",
                              placeholder: "开始时间",
                            },
                            on: { change: _vm.changeTime },
                            model: {
                              value: _vm.formData.rest_start,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "rest_start", $$v)
                              },
                              expression: "formData.rest_start",
                            },
                          }),
                          _vm._v("\n          -\n          "),
                          _vm.type !== "check"
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    size: "small",
                                    placeholder: "请选择",
                                    disabled:
                                      _vm.formData.rest_start_after == 1 ||
                                      _vm.formData.number1.second_day_after ==
                                        0,
                                  },
                                  on: { change: _vm.changeTime },
                                  model: {
                                    value: _vm.formData.rest_end_after,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "rest_end_after",
                                        $$v
                                      )
                                    },
                                    expression: "formData.rest_end_after",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-time-picker", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              clearable: false,
                              format: "H:mm",
                              size: "small",
                              placeholder: "结束时间",
                            },
                            on: { change: _vm.changeTime },
                            model: {
                              value: _vm.formData.rest_end,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "rest_end", $$v)
                              },
                              expression: "formData.rest_end",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips ml25" }, [
                            _vm._v("休息时间不计入工时"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formData.number == 1 &&
                  _vm.type == "check" &&
                  _vm.formData.rest_time == 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "中途休息时间：" } },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(_vm.formData.rest_start)
                                  .format("H:mm")
                              ) +
                                "-" +
                                _vm._s(
                                  _vm
                                    .$moment(_vm.formData.rest_end)
                                    .format("H:mm")
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v("休息时间不计入工时"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "加班起算时间：", prop: "title" } },
                    [
                      _vm.type !== "check"
                        ? _c("div", { staticClass: "item" }, [
                            _vm._v("\n            最后班次下班\n            "),
                            _c(
                              "div",
                              { staticClass: "mo-input--number" },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    "controls-position": "right",
                                    size: "small",
                                    min: 0,
                                  },
                                  model: {
                                    value: _vm.form.overtimeH,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "overtimeH", $$v)
                                    },
                                    expression: "form.overtimeH",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "define-append" }, [
                                  _vm._v("小时"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mo-input--number" },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    "controls-position": "right",
                                    size: "small",
                                    min: 0,
                                  },
                                  model: {
                                    value: _vm.form.overtimeM,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "overtimeM", $$v)
                                    },
                                    expression: "form.overtimeM",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "define-append" }, [
                                  _vm._v("分钟"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml10" }, [
                              _vm._v(" 后开始计算加班"),
                            ]),
                          ])
                        : _c("span", [
                            _vm._v(
                              "最后班次下班" +
                                _vm._s(_vm.form.overtimeH) +
                                "小时" +
                                _vm._s(_vm.form.overtimeM) +
                                "分钟后开始计算加班"
                            ),
                          ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.type !== "check"
                ? _c(
                    "div",
                    { staticClass: "button from-foot-btn fix btn-shadow" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleClose(1)
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.loading,
                            size: "small",
                          },
                          on: { click: _vm.submitForm },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }